import React from "react";
import NeedGuidance from "../NeedGuidance";
import WebinarEvents from "../WebinarEvents";
import { isFrappeOrJotFormClass } from "../../utils/helpers";
import UeTable from "./UeTable/UeTable";
import HeroSection from "./HeroSection/HeroSection";
import { format } from "date-fns";
import fetchUtil from "../../utils/fetchUtil";

const fetchEvents = async ({ searchValue, eventType, studydestination, city, startDate, endDate, limit = 20, page = 1 }: any) => {
  const search = searchValue ? `&eventName_contains=${searchValue}` : "";
  const type = eventType ? `&eventType=${eventType}` : "";
  const stuDest = studydestination ? `&studydestination=${studydestination}` : "";
  const cityField = city ? `&cities_contains=${city}` : "";
  const fromDate = startDate ? `&startDate_gte=${format(startDate, "yyyy-MM-dd")}` : "";
  const toDate = endDate ? `&startDate_lte=${format(endDate, "yyyy-MM-dd")}` : "";
  const limitParam = limit ? `&_limit=${limit}` : "";

  return fetchUtil(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/events?_sort=startDate:ASC&showInTable=true&_start=${limit * (page - 1)}${search}${type}${stuDest}${cityField}${fromDate}${toDate}${limitParam}`,
    "GET",
    {},
    "",
    false,
  )
    .then((res: any) => res ?? {})
    .catch((err) => err);
};

const UpcomingEvent: React.FC = (props: any) => {
  return (
    <>
      <HeroSection heroSectionData={props.pageData} />
      <WebinarEvents />
      {/* <EventCardsSection props={props} fetchEvents={fetchEvents} /> */}

      {props?.eventsData?.data && props?.eventsData?.data?.length > 0 && (
        <UeTable
          tableData={props?.eventsData}
          tableTitle={props.pageData?.tableTitle}
          studyDestinationData={props?.studyDestinationList}
          cities={props?.citiesData}
          fetchEvents={fetchEvents}
        />
      )}
      <NeedGuidance
        button2Data={{
          formId: props.pageData?.meta?.jotforms?.[0]?.jotformid || 'main-enquiry-form',
        }}
      />
    </>
  );
};

export default UpcomingEvent;
